module.exports = __webpack_public_path__ + "static/media/srcset-demo.6086fc60.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ep5/srcset-demo.jpg
 ** module id = 228
 ** module chunks = 0
 **/